import React from "react";
import AgendaManager from "./AgendaManager";

/** Agenda partagé en lecture seule pour l'espace collaborateur. */
const AgendaCollaborateurs = () => <AgendaManager companyAgenda />;

export default AgendaCollaborateurs;
